var map = {
	"./btavern/main.png": "0e95",
	"./btavern/screen_1.png": "21f9",
	"./btavern/screen_2.png": "9e07",
	"./btavern/screen_3.png": "f437",
	"./delta/main.png": "8fca",
	"./delta/screen_1.png": "f248",
	"./delta/screen_2.png": "2450",
	"./delta/screen_3.png": "3de4",
	"./delta/screen_4.png": "37e8e",
	"./delta/screen_5.png": "02dc",
	"./dighis/main.png": "6920",
	"./dighis/screen_1.png": "d087",
	"./dighis/screen_2.png": "b6c3",
	"./dighis/screen_3.png": "c70d",
	"./dighis/screen_4.png": "bd93",
	"./dighis/screen_5.png": "ef87",
	"./dighis/screen_6.png": "a9e9",
	"./dighis/screen_7.png": "2a3b",
	"./medical.png": "dbd5",
	"./northeast/main.png": "ca3b",
	"./northeast/screen_1.png": "7f58",
	"./northeast/screen_2.png": "2d14",
	"./northeast/screen_3.png": "bfac",
	"./ownbot/main.png": "fc68",
	"./ownbot/screen_1.png": "d506",
	"./ownbot/screen_2.png": "3bbb",
	"./ownbot/screen_3.png": "bd97",
	"./ownbot/screen_4.png": "059e",
	"./ownbot/screen_5.png": "2910",
	"./ownbot/screen_6.png": "2924",
	"./ownbot/screen_7.png": "e3c2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e9ac";